import { FilterOption } from "@/types";

export const getOption = (name: string, options: FilterOption[]): string => {
  if (!name || !Array.isArray(options)) {
    return "";
  }
  return options.find((option) => option.name === name)?.label || "";
};

export function allHaveKey<T, K extends keyof T>(
  arr: T[],
  key: K
): arr is (T & Record<K, NonNullable<T[K]>>)[] {
  return arr.every(item => item[key] !== undefined)
}
